import { makeApiCall } from "../apirequest";

export default {
  state: {
    templates: [],
  },
  getters: {
    getTemplates: (state) => state.templates,
  },
  actions: {
    async createTemplate({ commit }, payload) {
      let url = "template/SaveTemplate";
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },
    async getTemplates({ commit }, payload) {
      let url = "Admin/GetTemplateForAdmin";
      const response = await makeApiCall(url, "POST", payload);
      if (!response.error) {
        commit("setTemplates", response.data);
      }
      return response;
    },
    async deleteTemplate({ commit }, id) {
      let url = `Admin/GenericTemplateDelete?TemplateId=${id}`;
      const response = await makeApiCall(url, "DELETE");
      return response;
    },
    async dragdroptemplate({ commit }, payload) {
      let url = `Admin/DragAndDropTemplate`;
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },
    async duplicatetemplate({ commit }, id) {
      let url = `Admin/CreateDuplicateTemplateAndTasksForAdmin?templateId=${id}`;
      const response = await makeApiCall(url, "POST");
      return response;
    },
    async SaveTemplateByAdmin({ commit }, payload) {
      let url = "Admin/SaveTemplateByAdmin";
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },

  },
  mutations: {
    setTemplates: (state, payload) => (state.templates = payload),
  },
};
